export const EDITOR_PRESETS_MODAL_BUTTONS = 'Buttons';
